import { ArcwarePixelStreaming } from "../ArcwarePixelStreaming";

export enum WebsocketState {
  // Socket has been created. The connection is not yet open.
  CONNECTING = 0,
  // The connection is open and ready to communicate.
  OPEN = 1,
  // The connection is in the process of closing.
  CLOSING = 2,
  // The connection is closed or couldn't be opened.
  CLOSED = 3,
}

export class ConnectionIdentifier {
  private static instance: ConnectionIdentifier;
  public static get Instance() {
    if (!this.instance) {
      this.instance = new ConnectionIdentifier();
    }

    return this.instance;
  }

  private interval: any;

  private aps: ArcwarePixelStreaming[] = [];

  public get WebsocketStates() {
    return this.aps.map((ps) => ps.websocketState);
  }

  private constructor() {}

  public register(ps: ArcwarePixelStreaming): void {
    if (!this.aps.includes(ps)) {
      this.aps.push(ps);

      if (ps.config.settings?.connectionIdentifierLoggingDisabled) this.disable();
    }
    if (!this.interval) this.interval = setInterval(this.connectionWatcher.bind(this), 10 * 1000);
  }

  public GetWebSocketStates() {
    return this.aps.map((ps) => ps.websocketState);
  }

  public ActiveInstances() {
    return this.GetWebSocketStates().filter((state) => state <= WebsocketState.OPEN).length;
  }

  private enabled = true;
  public disable() {
    this.enabled = false;
  }

  /**
   * The purpose of this method is to periodically tell the developer the amount of connected instances.
   * This way the developer can figure out, when they messed up the implementation and there's shadow instances still running.
   * Or when they accidentally set up multiple connections!
   * Things like that can happen, for example if the React.useEffect was not setup perfectly!
   */
  private connectionWatcher() {
    if (!this.enabled) return;
    const activeStates = this.GetWebSocketStates().filter((state) => state <= WebsocketState.OPEN);

    if (activeStates.length === 1) {
      console.log(`PixelStreaming Instance is connected.`);
    } else if (activeStates.length !== 0) {
      console.warn(`${activeStates.length} PixelStreaming Instances are connected!`);
    }
  }
}
